import { useSyncExternalStore } from 'react';

let current: string | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;
const listeners = new Set<() => void>();

function setCurrent(id: string | null) {
  current = id;
  listeners.forEach((l) => l());
  if (timer) clearTimeout(timer);
  if (id) timer = setTimeout(() => setCurrent(null), 8000);
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useSamplePlayer(id: string) {
  const playing = useSyncExternalStore(subscribe, () => current === id);
  return {
    playing,
    toggle: () => setCurrent(current === id ? null : id),
  };
}
